export default "__VITE_ASSET___Z1KjpLP__"